<!-- Page unique : gestion utilisateurs (module analyse + module mandat). variant=extended inclut création client. -->
<template>
  <div class="admin-premium-page">
    <div class="admin-premium-page__inner">
      <div class="admin-premium-stack">
      <card :title="createCardTitle" :sub-title="createCardSubtitle">
        <FormUserBackoffice v-if="variant === 'backoffice'" />
        <FormUserExtended v-else />
      </card>

      <card :title="clientsCardTitle" :sub-title="clientsCardSubtitle">
        <ClientStandardList />
      </card>

      <card :title="employesCardTitle" :sub-title="employesCardSubtitle">
        <EmployeList />
      </card>
      </div>
    </div>
  </div>
</template>

<script>
import FormUserBackoffice from '@/views/patrimoine/admin/FormUser.vue';
import FormUserExtended from '@/components/mandat/FormUser.vue';
import EmployeList from '@/components/shared/EmployeList.vue';
import ClientStandardList from '@/components/patrimoine/ClientStandardList.vue';

export default {
  name: 'GesUserPage',
  components: {
    FormUserBackoffice,
    FormUserExtended,
    EmployeList,
    ClientStandardList,
  },
  props: {
    /** backoffice = formulaire employé/admin uniquement ; extended = employé, admin ou client */
    variant: {
      type: String,
      default: 'backoffice',
      validator: (v) => ['backoffice', 'extended'].includes(v),
    },
  },
  computed: {
    createCardTitle() {
      return this.variant === 'extended' ? 'Créer un utilisateur' : 'Créer un employé';
    },
    createCardSubtitle() {
      return this.variant === 'extended'
        ? 'Employé, administrateur ou client (inscription back-office). Les clients peuvent aussi s’inscrire via la page publique.'
        : 'Conseillers et administrateurs uniquement. Les clients s’inscrivent via la page d’inscription publique.';
    },
    clientsCardTitle() {
      return 'Liste des clients';
    },
    clientsCardSubtitle() {
      return this.variant === 'extended'
        ? 'Comptes client : consultation, recherche et actions selon vos droits (inclut l’inscription back-office le cas échéant).'
        : 'Comptes client du module analyse — recherche et filtre par rôle (client, client pro, etc.).';
    },
    employesCardTitle() {
      return this.variant === 'extended' ? 'Liste des conseillers' : 'Liste des employés';
    },
    employesCardSubtitle() {
      return this.variant === 'extended'
        ? 'Employés rattachés (conseillers) et comptes administrateur.'
        : 'Conseillers et administrateurs rattachés à la plateforme.';
    },
  },
};
</script>
